"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nlLocaleData = require("i18next-icu/locale-data/nl");
exports.default = nlLocaleData;
//# sourceMappingURL=nl.js.map